export default __webpack_public_path__ + "static/google-logo-53e79f7a52f093d87a13e15e6103b290.svg";